export default __webpack_public_path__ + "static/media/logo.314f0e8b.png";